module.exports = __webpack_public_path__ + "static/media/PhoneNumber.24f429be.svg";